var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIconSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.5,
    height: 38.222,
    viewBox: "0 0 34.5 38.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6415",
    "data-name": "Groupe 6415",
    transform: "translate(-1247.5 -804.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_697",
    "data-name": "Trac\\xE9 697",
    d: "M9.306,0h9.306V9.306a5.583,5.583,0,0,0,5.583,5.583H33.5V27.917a9.305,9.305,0,0,1-9.306,9.306H9.306A9.305,9.305,0,0,1,0,27.917V9.306A9.305,9.305,0,0,1,9.306,0M23.873,21.506a1.862,1.862,0,0,0-.514-2.582L17.784,15.2a1.862,1.862,0,0,0-2.066,0l-5.583,3.722a1.861,1.861,0,1,0,2.065,3.1l2.69-1.793v7.722a1.861,1.861,0,1,0,3.722,0V20.23l2.68,1.79a1.862,1.862,0,0,0,2.581-.514",
    transform: "translate(1248 805.111)",
    fill: "#d9e7fd",
    stroke: "#4188f2",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_698",
    "data-name": "Trac\\xE9 698",
    d: "M192,9.371l10.077,10.077h-8.215A1.861,1.861,0,0,1,192,17.587Z",
    transform: "translate(1078.333 796.83)",
    fill: "#d9e7fd",
    stroke: "#4188f2",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconSmall);
export default __webpack_public_path__ + "static/media/download-icon-small.72ec1c2cbf49bf72f0077042fb84b4f4.svg";
export { ForwardRef as ReactComponent };